<div id="help-button" class="link-button">
    <a (click)="showHelp()">
        <i class="fa fa-question-circle" aria-hidden="true"></i><div>Help!</div>
    </a>
</div>
